import { Box, Typography } from "@mui/material";
import theme from "../../theme";
import styled from "@emotion/styled";
import { ReactNode, useEffect, useState } from "react";
import { BottomSheet } from "./BottomSheet";
export type RadioOption = {
  label: string;
  value: string;
};

type Prop = {
  title: ReactNode;
  sort?: string;
  setSort?: React.Dispatch<React.SetStateAction<string | undefined>>;
  setOpenFilter?: React.Dispatch<React.SetStateAction<boolean>>;
  sortList?: RadioOption[];
  buttonsJustifyContent?: string;
  icon?: ReactNode;
};

export const TableTitle = ({
  title,
  sort,
  setSort,
  setOpenFilter,
  sortList,
  buttonsJustifyContent,
  icon,
}: Prop) => {
  const [openSort, setOpenSort] = useState(false);
  const [selectedRadio, setSeledtedRadio] = useState(``);

  useEffect(() => {
    if (!sortList) return;
    const selectedSort = sort?.slice(0, sort.indexOf(" "));
    const filterd = sortList.filter((el) => el.value === selectedSort);
    setSeledtedRadio(filterd[0].label);
  }, [sort, sortList]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "8px",
        marginBottom: `8px`,
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h2"
          fontSize={theme.fontSize.FONT_1}
          fontWeight={theme.fontWeight.SEMI_BOLD}
        >
          {title}
        </Typography>
        {/* Prop으로 전달된 아이콘 */}
        {icon}
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "6px",
          justifyContent: buttonsJustifyContent
            ? buttonsJustifyContent
            : "normal",
        }}
      >
        {setSort && (
          <SortButton
            onClick={() => {
              setOpenSort(true);
            }}
          >
            <span>{selectedRadio}</span>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
              >
                <path
                  d="M0 0L5 5L10 0H0Z"
                  fill={theme.color.neutral_300}
                />
              </svg>
            </div>
          </SortButton>
        )}
        {setOpenFilter && (
          <FilterButton onClick={() => setOpenFilter((prev) => !prev)}>
            <span>필터</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="9"
              viewBox="0 0 8 9"
              fill="none"
            >
              <path
                d="M5.45388 4.33147C5.44218 4.34769 5.43312 4.365 5.42745 4.38269C5.42179 4.39927 5.41915 4.4188 5.41915 4.44053V6.94412C5.41915 7.02776 5.40216 7.10771 5.36894 7.18176C5.33572 7.25545 5.28703 7.32214 5.22324 7.37925L3.60084 8.84162C3.51137 8.92268 3.40379 8.97352 3.29017 8.99195C3.17693 9.01074 3.05841 8.99674 2.94667 8.94884C2.83984 8.90315 2.75227 8.83241 2.6896 8.74399L2.68054 8.73146C2.6175 8.63714 2.5824 8.5255 2.5824 8.40649V4.44054C2.5824 4.4188 2.57976 4.39964 2.57409 4.38269C2.56843 4.36611 2.55975 4.34917 2.54767 4.33222L0.11141 0.931064C0.0453513 0.838953 0.00835857 0.735422 0.00118827 0.630413C-0.00560641 0.525037 0.0166652 0.417453 0.0698897 0.318708C0.122737 0.219595 0.199748 0.140015 0.292981 0.0851104C0.386596 0.0294756 0.494174 0 0.608174 0H7.39184C7.50622 0 7.6138 0.0298444 7.70703 0.0851104C7.80027 0.140377 7.87765 0.219962 7.93012 0.318708C7.98297 0.417821 8.00562 0.524669 7.99883 0.630413C7.99203 0.73579 7.95466 0.839317 7.8886 0.931432L5.45234 4.33183L5.45388 4.33147Z"
                fill={theme.color.green_500}
              />
            </svg>
          </FilterButton>
        )}
      </Box>

      {sortList && (
        <BottomSheet
          title="정렬"
          open={openSort}
          onClose={() => {
            setOpenSort(false);
          }}
          sortList={sortList}
          sort={sort}
          setSort={setSort}
        />
      )}
    </Box>
  );
};

const SortButton = styled.button`
  height: 24px;
  flex-grow: 1;
  padding: 3.5px 6px 4.5px;
  font-size: ${theme.fontSize.FONT_2};
  border-radius: ${theme.basic.BORDER_RADIUS};
  color: ${theme.color.neutral_500};
  background-color: ${theme.color.white};
  border: 0.5px solid ${theme.color.neutral_200};
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    flex-grow: 1;
  }
  > div {
    display: flex;
    padding-right: 4px; /** 오른쪽 패딩 합쳐서 10px */
  }
`;
const FilterButton = styled.button`
  height: 24px;
  width: 56px;
  flex-shrink: 0;
  padding: 3.5px 0px 4.5px;
  font-size: ${theme.fontSize.FONT_2};
  border-radius: ${theme.basic.BORDER_RADIUS};
  color: ${theme.color.green_500};
  background-color: ${theme.color.green_100};
  border: 0.5px solid ${theme.color.green_500};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5px;
`;
